// EmailLayout.jsx
import React from 'react';

const EmailLayout = ({ children }) => {
  return (
    <section
      className="login_inner"
      style={{ fontFamily: "'Poppins', sans-serif", marginBottom: '15px' }}
    >
      <div className="container">
        <div className="row">
          <div
            className="email"
            style={{
              padding: '15px',
              margin: '0 auto',
              maxWidth: '500px',
              background: '#f9f9f9',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {/* <div
              className="logo"
              style={{
                textAlign: 'left',
                width: '30%',
                display: 'inline-block',
              }}
            >
              <img
                src="https://smart-doc.co.uk/images/1st-choice-formation/logo.png"
                width="100%"
                alt="Logo"
              />
            </div> */}
            {/* <div
              className="text_rt"
              style={{
                textAlign: 'right',
                display: 'inline-block',
                width: '60%',
                padding: '0 0 0 40px',
              }}
            >
              <p style={{ fontSize: '13px' }}>
                Need help?{' '}
                <a href="https://www.1stchoice-formations.co.uk/contact-us/">
                  Contact Us
                </a>
              </p>
            </div> */}

            <div className="mail_body" style={{ textAlign: 'left', fontSize: '13px' }}>
              {children}
            </div>
          </div>
        </div>
      </div>

      <footer
        className="app-footer log_foot"
        style={{
          textAlign: 'center',
          padding: '5px 0',
          fontFamily: "'Poppins', sans-serif",
          fontSize: '12px',
        }}
      >
        {/* <div>
          <a href="javascript:void(0)" style={{ textDecoration: 'none' }}>
            Smart Docustore Ltd.
          </a>
          <span>© {new Date().getFullYear()} .</span>
        </div>
        <div className="termbox" style={{ textDecoration: 'none' }}>
          <a href="#" style={{ textDecoration: 'none' }}>
            Term and Conditions
          </a>
          <a href="#" style={{ textDecoration: 'none' }}>
            Privacy Policy
          </a>
        </div> */}
      </footer>
    </section>
  );
};

export default EmailLayout;
